export { default as DefaultPage } from './DefaultPage';



// WEBPACK FOOTER //
// ./src/features/events/index.js